<template>
  <v-container>
    <v-layout row wrap justify-space-around edoabstand>
  <v-flex xs12 md7>
    <div>
      <v-card class="my-3 blogcard" hover>
        <v-card-media
          class="white--text"
          height="450px"
          :src="post.bodyImgUrl"
        >
        </v-card-media>
        <v-card-text>
          <span class="headline">{{ post.title }}</span>
          <br><br>
          <span v-html="post.body"></span>
          <span style="color: lightgrey;"><span v-html="post.date"></span></span>
        </v-card-text>
        <v-card-actions>
         <!-- <v-btn @click="goToURL('https://twitter.com/')" icon class="light-blue--text">
            <v-icon medium>fa-twitter</v-icon>
          </v-btn>
          <v-btn @click="goToFacebookURL(post)" icon class="blue--text text--darken-4">
            <v-icon medium>fa-facebook</v-icon>
          </v-btn>-->
          <v-spacer></v-spacer>
          <v-btn to="/Blog" flat class="blue--text">Zurück</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import blogJson from '../assets/blog/blog.json'
  export default {
    name: 'Blog',
    data () {
      return {
        posts: blogJson,
        post: {
          title: 'becci',
          content: 'content',
          body: 'body',
          date: 'date',
          imgUrl: ''
        }
      }
    },
    methods: {
      goToFacebookURL: function (blogItem) {
        var host = 'http://localhost:8080/#/Blog'
        var url = 'http://www.facebook.com/sharer.php?s=100&p[title]=' + encodeURIComponent(blogItem.title)
        url += '&p[summary]=' + encodeURIComponent(blogItem.content)
        url += '&p[url]=' + encodeURIComponent(host + '/' + blogItem.id)
        url += '&p[images][0]=' + encodeURIComponent(blogItem.bodyImgUrl)
        console.log(url)
        // window.location.href = url
      },
      goToURL: function (url) {
        window.location.href = url
      }
    },
    mounted () {
      console.log('Blog')
      var cmp = this
      var blogId = this.$route.params.blogId

      this.posts.forEach(function (item) {
        if (item.id === blogId) {
          cmp.post = item
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BlogContent.vue